
class ExportarArquivo {
	constructor(response) {
		this.response = response;
	}

	arquivo() {
		const content = this.response.headers['content-disposition']
    const url = window.URL.createObjectURL(new Blob([this.response.data]))
    const link = document.createElement('a')
		link.href = url
    link.setAttribute('download', content.substring(content.indexOf('"') + 1, content.lastIndexOf('"')))
    document.body.appendChild(link)
    link.click()
	}
}

export default ExportarArquivo;